import { render, staticRenderFns } from "./PolicyDocumentAddedNotification.vue?vue&type=template&id=4024f908&scoped=true&"
import script from "./PolicyDocumentAddedNotification.vue?vue&type=script&lang=js&"
export * from "./PolicyDocumentAddedNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4024f908",
  null
  
)

export default component.exports